import { isEmptyObject } from "utilities/common";


export function subTraitValidation(fields) {
    const errors= {};

    if (!fields.subTraitName) {
        errors.subTraitName = "Subtrait name is required";
    }

    // if (!fields.value) {
    //     errors.value = "Value is required"
    // }

    // if (!fields.unit) {
    //     errors.unit = "Unit is required"
    // }

    return { errors, isValid: isEmptyObject(errors)}

}